import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    animationClass: { type: String, default: "fade-out" },
  };

  connect() {
    // Use requestAnimationFrame to ensure the element is rendered
    // before the transition class is applied.
    requestAnimationFrame(() => {
      this.element.classList.add(this.animationClassValue);
    });

    this.element.addEventListener(
      "transitionend",
      () => {
        this.element.remove();
      },
      { once: true }
    );

    // Fallback
    setTimeout(() => {
      if (this.element.parentNode) {
        this.element.remove();
      }
    }, 500);
  }
}
